























helpers = require('../../helpers.coffee')

view_model =
  mixins: [require('../../mixins/users_options.coffee')]

  props: ['filters']

  data: ->
    users_options: [{ value: null, text: 'Carregando...'}]
    user_filter: @extractFilter('user_id_eq')
    task_type_options: @taskTypeOptions()
    task_type_filter: @extractFilter('service_eq')
    search_contact_filter: @filters.search_contacts

  computed:
    show_user_filter: ->
      !Session.current_user.isSeller()

  methods:
    defaultFilters: ->
      filters = Object.assign({}, @user_filter || {})

      filters.assigned_to_id_eq = @user_filter.user_id_eq if @user_filter
      filters.search_contacts   = @search_contact_filter if @search_contact_filter
      filters.service_eq        = @task_type_filter.service_eq if @task_type_filter

      filters.done_at_null = true
      filters.s = ['due_on asc', 'id desc']
      filters

    filterUrlParams: ->
      url_params    = {}
      permited_keys = ['service_eq', 'search_contacts']
      permited_keys.push('user_id_eq') unless Session.current_user.isSeller()

      for key, value of @defaultFilters()
        continue unless value?
        # humanize query values of service_eq
        value = value.split('::').last() if key == 'service_eq'
        url_params[key] = value if permited_keys.includes(key)
      url_params

    reloadTasks: ->
      @applyFiltersOnUrlQueryParams(@filterUrlParams())
      @$emit('filter', @defaultFilters())

    taskTypeOptions: ->
      options = Task.availableManualTaskServices.map (option)->
        { value: { service_eq: option.service }, text: option.human_name }
      options.unshift({ value: null, text: 'Todas as tarefas' })
      options

  watch:
    user_filter: ->
      IntercomCtrl.trackEvent('Uso do filtro de usuários para as atividades pendentes')

exports.default = helpers.vue_include(view_model, helpers.manual_tasks.list_wrapper, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/filters.vue